var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 11.6325V16.5733C14.6666 18.7183 13.2366 20.1392 11.1008 20.1392H5.39915C3.26331 20.1392 1.83331 18.7183 1.83331 16.5733V9.45084C1.83331 7.30584 3.26331 5.88501 5.39915 5.88501H8.90998C9.85415 5.88501 10.7616 6.26084 11.4308 6.93001L13.6216 9.11168C14.2908 9.78084 14.6666 10.6883 14.6666 11.6325Z",
    stroke: "#F0F0FC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.1666 7.56251V12.5033C20.1666 14.6392 18.7366 16.0692 16.6008 16.0692H14.6666V11.6325C14.6666 10.6883 14.2908 9.78085 13.6216 9.11168L11.4308 6.93001C10.7616 6.26085 9.85415 5.88501 8.90998 5.88501H7.33331V5.37168C7.33331 3.23585 8.76331 1.80585 10.8991 1.80585H14.41C15.3541 1.80585 16.2616 2.18168 16.9308 2.85085L19.1216 5.04168C19.7908 5.71085 20.1666 6.61835 20.1666 7.56251Z",
    stroke: "#F0F0FC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.cff8bc2bb865b0a5e70e359e30616b12.svg";
export { ForwardRef as ReactComponent };